import { Icon } from '@kinesis/bungle';

const UnlockFilledIcon = (props: any) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Icon type='custom' {...props}>
    <svg width='1024' height='1024' viewBox='0 0 1024 1024' fill='none'>
      <path
        // eslint-disable-next-line max-len
        d='M832 464H332V240C332 209.1 357.1 184 388 184H636C666.9 184 692 209.1 692 240V308C692 312.4 695.6 316 700 316H756C760.4 316 764 312.4 764 308V240C764 169.3 706.7 112 636 112H388C317.3 112 260 169.3 260 240V464H192C174.3 464 160 478.3 160 496V880C160 897.7 174.3 912 192 912H832C849.7 912 864 897.7 864 880V496C864 478.3 849.7 464 832 464ZM540 701V754C540 758.4 536.4 762 532 762H492C487.6 762 484 758.4 484 754V701C475.745 695.073 469.584 686.681 466.403 677.029C463.222 667.378 463.185 656.967 466.298 647.293C469.411 637.62 475.513 629.184 483.726 623.199C491.938 617.215 501.838 613.991 512 613.991C522.162 613.991 532.062 617.215 540.274 623.199C548.487 629.184 554.589 637.62 557.702 647.293C560.815 656.967 560.778 667.378 557.597 677.029C554.416 686.681 548.255 695.073 540 701Z'
      />
    </svg>
  </Icon>
);

export { UnlockFilledIcon };
